import React from 'react';

function Error() {
  return (
    <div>
      <h3 className="u-clr-white">The page/service you are trying to access is temporarily unavailable due to system maintenance.</h3>
      <p className="u-padding-m-top">Please try again in four hours.</p>
    </div>
  );
}

export default Error;
